import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { useChartColors } from './useChartColors';

interface DonutDataItem {
  name: string;
  value: number;
  color?: string;
}

interface BaseDonutChartProps {
  data: DonutDataItem[];
  height?: number;
  innerRadius?: number;
  outerRadius?: number;
  showLegend?: boolean;
  centerLabel?: string;
  centerValue?: string;
}

export default function BaseDonutChart({
  data,
  height = 200,
  innerRadius = 55,
  outerRadius = 80,
  showLegend = true,
  centerLabel,
  centerValue,
}: BaseDonutChartProps) {
  const colors = useChartColors();

  return (
    <div className="relative">
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={2}
            dataKey="value"
          >
            {data.map((entry, i) => (
              <Cell key={entry.name} fill={entry.color || colors[i % colors.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{ backgroundColor: 'var(--color-bg-card)', border: '1px solid var(--color-border)', borderRadius: 8, fontSize: 12 }}
          />
          {showLegend && (
            <Legend
              wrapperStyle={{ fontSize: 11 }}
              formatter={(value) => <span style={{ color: 'var(--color-text-secondary)' }}>{value}</span>}
            />
          )}
        </PieChart>
      </ResponsiveContainer>
      {centerValue && (
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" style={{ top: showLegend ? -20 : 0 }}>
          <span className="text-lg font-bold text-content-primary">{centerValue}</span>
          {centerLabel && <span className="text-xs text-content-muted">{centerLabel}</span>}
        </div>
      )}
    </div>
  );
}
